import { useI18n } from '../../i18n'
import { useScrollAnim } from '../../hooks/use-scroll-anim'
import { Sparkles } from 'lucide-react'

export function PricingHero() {
  const { t } = useI18n()
  const { ref, isVisible } = useScrollAnim()

  return (
    <section ref={ref} className="pt-14 pb-6 text-center">
      <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-orange-50 border border-orange-100 text-orange-600 text-xs font-medium mb-6">
          <Sparkles className="h-3.5 w-3.5" />
          {t('灵活定价，按需选择', 'Flexible pricing, choose what you need')}
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-4">
          {t('选择适合你的套餐', 'Choose the Right Plan for You')}
        </h1>
        <p className="text-gray-400 text-sm max-w-lg mx-auto">
          {t(
            '从免费体验到企业定制，满足不同规模团队需求。按月或按年订阅，年付享8折优惠。',
            'From free trial to enterprise custom, plans for teams of any size. Save 20% with annual billing.'
          )}
        </p>
      </div>
    </section>
  )
}
